import styled from 'styled-components';

const WrappedPre = styled.pre`
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-wrap;
  word-break: break-word;

  padding: 5px;
  background-color: #f8f8f8;
  border: 1px solid #e0e0e0;
`;

export default WrappedPre;



// WEBPACK FOOTER //
// ./src/util/WrappedPre.js